import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { Rank, PagedResponseRank } from '../models/Rank';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class RankService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getRanks():Observable<PagedResponseRank>{
    const data =  this.http.get<PagedResponseRank>(this.APIURL+'/Rank' + '?PageNumber=1&PageSize=100');
    this.messageService.add('Rank Service: fetched Ranks');
    return data;
  }

  getRank(id: number): Observable<Rank> {
        const Rank =this.http.get<Rank>(this.APIURL+'/Rank/' + id);
    this.messageService.add(`Rank Service: fetched Rank with id=${id}`);
    return Rank;
  }
}